import React, { ReactElement, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { User, FetchedVCDataMulti, DataVC2 } from 'types/Types';
import { Button } from 'ui/atoms/Button';
import axios from 'axios';
import { useAuth } from 'contexts/AuthContext';
import { API_ADDRESS } from 'config/config';
import { TextConstant } from '../../../config/text-constant';
import { CUSTOM_SHOPS_ARRAY, CustomShop } from '../../../config/customShopsConstants';

type ConfirmPickupMultiCreationProps = {
    pickupData: FetchedVCDataMulti;
    user: User;
    setSuccess: (data: boolean) => void;
    setLoading: (data: boolean) => void;
    setError: (data: string) => void;
    setTxLink: React.Dispatch<React.SetStateAction<string | null>>;
};

/*type DataVC2Multi = {
    recipient: string;
    subject: {
        _id: string;
        description: string;
        quantity: number;
        unit: string;
        date: string;
    }[];
    proof: string;
    zadruga?: string;
};*/

const ConfirmPickupMultiCreation = ({
    pickupData,
    user,
    setSuccess,
    setLoading,
    setError,
    setTxLink,
}: ConfirmPickupMultiCreationProps): ReactElement => {
    const { currentUser } = useAuth();

    const mapSubjects = () =>
        pickupData.data.subject.map((subject) => ({
            _id: subject.crop._id,
            description: subject.description,
            quantity: subject.quantity,
            unit: subject.unit,
            date: subject.date,
        }));

    const confirmPickupMultiCreationHandler = () => {
        let testZadruga = '';
        CUSTOM_SHOPS_ARRAY.forEach((c) => {
            if (c.userId == user.sifra) {
                console.log('user found');
                testZadruga = c.groupId + '|' + c.shopId;
            }
        });
        if (testZadruga == '') {
            //remains the same from version before zadruga
            const vcData = {
                recipient: user.ethWallet.address,
                subject: mapSubjects(),
                proof: pickupData.ipfsAddress,
            };
            console.log('Brez zadruge', vcData);
            //confirmPickupMultiCreation(vcData);
        } else {
            const vcData = {
                recipient: user.ethWallet.address,
                subject: mapSubjects(),
                proof: pickupData.ipfsAddress,
                zadruga: testZadruga,
            };
            console.log('Z zadrugo', vcData);
            //confirmPickupMultiCreation(vcData);
        }
    };

    const confirmPickupMultiCreation = (data: DataVC2) => {
        setLoading(true);
        axios
            .post(
                `${API_ADDRESS}/vc/create/vc2`,
                {
                    data: data,
                },
                { headers: { Authorization: `Bearer ${currentUser.token}` } },
            )
            .then((res) => {
                setTxLink(res.data.txLink);
                setSuccess(true);
            })
            .catch((err) => console.error(err))
            .finally(() => setLoading(false));
    };

    return (
        <CreatePickupMultiCreationWrapper>
            <h3>Informacije o prevzemniku:</h3>
            <ListSection>
                <div>Uporabniško ime: {user.username}</div>
                <div>Tip podjetja: {user.userType}</div>
                <div>Email: {user.email}</div>
            </ListSection>
            <h3>Seznam pridelkov:</h3>
            {pickupData.data.subject.map((subject) => {
                return (
                    <ListSection key={subject.crop._id}>
                        <div>
                            <div>Naziv: {subject.crop.name}</div>
                            <div>Opis: {subject.description}</div>
                            <div>Količina: {subject.quantity}</div>
                            <div>Enota: {subject.unit}</div>
                            <div>
                                {TextConstant.DATE_OF_SOWING} {subject.date}
                            </div>
                        </div>
                    </ListSection>
                );
            })}
            <BottomWrapper>
                <Button onClick={confirmPickupMultiCreationHandler} text="Potrdi" btnType="primary" />
            </BottomWrapper>
        </CreatePickupMultiCreationWrapper>
    );
};

export default ConfirmPickupMultiCreation;

const CreatePickupMultiCreationWrapper = styled.div`
    flex: 1 1 auto;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

const ListSection = styled.div`
    border: 1px solid #d8dbe0;
    padding: 4px;
    margin-bottom: 6px;
`;

const BottomWrapper = styled.div`
    margin-top: auto;
`;
